import React, { useState } from "react";
import "./RJSCDetailRenewReview.styles.scss";
import { connect } from "react-redux";
import Modal from "react-modal";
import { rjscDetailReviewSelect } from "../../redux/selector/rjscSearchSelector";
import {
	Header,
	Paragraph,
	Button,
	ErrorMark,
	MortgageRegulationContacts
	// LineSeperator,
	// SubHeader,
	// ErrorMark
} from "../../components/RegularComponents";
import { push } from "connected-react-router";
import TopNavigationBar from "../TopNavigationBar";
import * as CONST from "../../app/constants";
import { replaceUrlParams } from "../../app/utils";
import Navigation from "../Navigation";
import ReviewForm from "../../components/ReviewForm/ReviewForm";
import {
	APPLICATION_MODE_RENEW,
	APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
	APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
	APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
	ROUTE_PATH
} from "../../app/constants";
// import { ERROR_STRING } from "../../app/errors";
// import CheckboxForm from "../../components/CheckBoxForm";
import CompliaceOfficerConfirm from "../../components/RJSCReview/ComplianceOfficerConfirm";

const RJSCDetailsRenewalReview = (props) => {
	const { rjscDetailReview } = props;
	const { applicationType, applicationMode } = props.match.params;

	const [showCompanyNotActiveError, setShowCompanyNotActiveError] = useState(false);
	const [complaiceOfficerCheck, setComplaiceOfficerCheck] = useState(false);
	const [unmatchedComplianceOfficerError, setUnmatchedComplianceOfficerError] = useState(false);
	const [showComplianceOfficerError, setShowComplianceOfficerError] = useState(false);
	const [showUpdateRjscDetailDialog, setShowUpdateRjscDetailDialog] = useState(false);

	const notRegistered = !rjscDetailReview?.companyRjscData?.businessEntity?.entityId;

	// move on to the application review
	const handleYesClick = () => {
		const validation =
			rjscDetailReview?.companyRjscData?.status === "ACTIVE" ||
			!rjscDetailReview?.companyRjscData?.businessEntity;

		if (!validation) {
			// show an error message explaining the problem
			setShowCompanyNotActiveError(true);
			return;
		}

		let nextUrl = CONST.ROUTE_PATH.APPLICATION_RENEWAL_REVIEW;

		if (applicationMode === APPLICATION_MODE_RENEW) {
			// if (
			// 	!complaiceOfficerCheck &&
			// 	(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
			// 		applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE)
			// ) {
			// 	setUnmatchedComplianceOfficerError(true);
			// 	return;
			// }

			if (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
				nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
			} else if (applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
				nextUrl = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
			} else if (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
				nextUrl = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RENEWAL_CONTENT_AWARENESS}`;
			}
		} else {
			if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
				nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_CONTENT_AWARENESS}`;
			} else if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
				nextUrl = `${CONST.ROUTE_PATH.ML_APP}${CONST.ROUTE_PATH.RENEWAL_REGULATION_ACT}`;
			}
		}
		props.dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)));
	};

	// show RJSC search
	const handleNoClick = () => {
		const nextUrl = CONST.ROUTE_PATH.RJSC_SEARCH;
		// For Mortgage brokerage flow fixes needed for NB Exempt flow
		// if (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
      	// 	props.dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_SEARCH}`));
    	// }
		// else {
		// 	props.dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)));
		// }

		props.dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)));
		
	};

	const rjscUpdateComponent = (
		<>
			{notRegistered ? null : (
				<Button
					id="update-rjsc-button-id"
					text="Update company information in RJSC"
					buttonType="regular_link"
					onClick={() => setShowUpdateRjscDetailDialog(true)}
				/>
			)}
		</>
	);

	return (
		<>
			<Navigation {...props} />
			<div className={"container"}>
				<TopNavigationBar {...props} hideSaveAndExit={false} />
				<div className="row">
					<div className="col-lg-8">
						<Header
							id="rjsc-detail-review-header"
							header={`Review business name ${notRegistered ? "" : "and Registry of Joint Stock Companies (RJSC) Number"}`}
						/>
						<div className="topMarginLarge">
							<Paragraph
								id="rjsc-detail-review-text-1"
								text={[`The following information was submitted in the previous year.`]}
							/>
							<Paragraph
								id="rjsc-detail-review-text-2"
								text={[
									notRegistered
										? null
										: `If your business information is <b>out of date</b>, update it with the <a href="${CONST.RJSC_UPDATE_LINK}" target="blank">Registry of Joint Stocks</a> (RJSC) before you continue your application.`
								]}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-8">
						<Paragraph style={{ fontSize: "1.65em" }} text={["Company information"]} />
					</div>
				</div>
				<div className="row bottomMarginNormal">
					<div className="col-lg-8">
						<ReviewForm data={rjscDetailReview.companyReview} fullSize={true} />
					</div>
				</div>
				<div className="row bottomMarginNormal">{rjscUpdateComponent}</div>
				<div className="row">
					<div className="col-lg-8">
						<Paragraph
							style={{ fontSize: "1.65em" }}
							text={[notRegistered ? "Officials listed" : "Officials listed under RJSC"]}
						/>
					</div>
				</div>
				<div className="row bottomMarginNormal borderItemNotLast alternateHighlight">
					<div className="col-lg-8">
						{rjscDetailReview.peopleReview.map((pReview) => {
							return (
								<div
									className="borderItemNotLastRow alternateHighlightRow"
									style={{ padding: "10px" }}
								>
									<ReviewForm data={pReview} fullSize={true} />
								</div>
							);
						})}
					</div>
				</div>
				{applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
					applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE ? (
					<>
						<div className="row">
							<div className="col-lg-8">
								<Paragraph
									id="provide-new-info-text"
									text={[`Provide new registry information if your registry id has changed.`]}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-8">
								<Button
									id={"modify-rjsc-button"}
									text={"Provide new RJSC information"}
									buttonType={"regular_primary"}
									onClick={handleNoClick}
								/>
							</div>
						</div>
					</>
				) : (
					<div className="row">
						<div className="col-lg-8">{rjscUpdateComponent}</div>
					</div>
				)}

				<CompliaceOfficerConfirm
					applicationMode={applicationMode}
					applicationType={applicationType}
					complaiceOfficerCheck={complaiceOfficerCheck}
					setComplaiceOfficerCheck={setComplaiceOfficerCheck}
					unmatchedComplianceOfficerError={unmatchedComplianceOfficerError}
					setUnmatchedComplianceOfficerError={setUnmatchedComplianceOfficerError}
				/>
				{applicationMode === APPLICATION_MODE_RENEW &&
					0 &&
					(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
						applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) ? (
					<div className="row topMarginNormal">
						<div className="col-auto">
							<div className="has-error">
								<div className="help-block">
									<Button
										id={"rjsc-detail-save-next"}
										text={"Save and next"}
										buttonType={"regular_primary"}
										onClick={handleYesClick}
									/>
									{showCompanyNotActiveError && (
										<span style={{ marginLeft: "5px" }}>
											<i className="fa fa-exclamation-circle" aria-hidden="true"></i>
										</span>
									)}
								</div>
							</div>
						</div>
					</div>
				) : (
					<>
						{(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE ||
							CONST.APPLICATION_TYPE_COLLECTION_AGENCY ||
							CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) && (
								<div className="topMarginNormal">
									<Paragraph
										id="rjsc-detail-review-accuracy-text"
										text={[`Is this business information accurate?`]}
									/>
								</div>
							)}
						<div
							className={`row bottomMarginNormal ${showComplianceOfficerError ? "has-error" : ""}`}
						>
							<div className="col-lg-8">
								<div className="row">
									<div className="col-lg-3 col-ls-2">
										<Button
											className="ns-btn-yes-no btn-default"
											id={"rjsc-detail-yes-button"}
											text={"Yes"}
											buttonType={"regular_primary"}
											onClick={handleYesClick}
										/>
									</div>
									<div className={`col-lg-5 ${showComplianceOfficerError ? "has-error" : ""}`}>
										<Button
											className="ns-btn-yes-no btn-default"
											id={"rjsc-detail-no-button"}
											text={"No"}
											buttonType={"regular_primary"}
											onClick={() => {
												if (
													applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
													applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE
												) {
													setShowComplianceOfficerError(true);
												} else {
													handleNoClick();
												}
											}}
										/>
										{showComplianceOfficerError && ErrorMark()}
										{showComplianceOfficerError && (
											<MortgageRegulationContacts
												message="If you do not meet the qualifications you must assign
											a different Compliance Officer who meets the qualifications.
											To assign a different Compliance Officer, contact Business Licensing:"
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>

			<Modal
				appElement={document.getElementById("root")}
				isOpen={showUpdateRjscDetailDialog}
				contentLabel="rjscDetailUpdateDialog"
				onRequestClose={() => { }}
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
				className="modalDialogContent updateRjscDetailDialog"
				closeTimeoutMS={150}
			>
				<div className="row pull-right">
					<div
						className="col-lg-1 closeButton"
						onClick={() => {
							setShowUpdateRjscDetailDialog(false);
						}}
					>
						<i className="fa fa-2x fa-times"></i>
					</div>
				</div>
				<Header header={rjscDetailReview.updateRjscDetailDialog.header} />
				<p
					dangerouslySetInnerHTML={{
						__html:
							applicationMode === APPLICATION_MODE_RENEW
								? rjscDetailReview.updateRjscDetailDialog.htmlTextRenewal
								: rjscDetailReview.updateRjscDetailDialog.htmlText
					}}
				></p>
				<a
					className={"btn btn-primary"}
					href={CONST.RJSC_UPDATE_LINK}
					target={"_blank"}
					rel={"noreferrer"}
					id={"update-rjsc-anchor"}
					style={{ marginTop: "20px" }}
				>
					{"Continue to RJSC"}
				</a>
			</Modal>
		</>
	);
};

export default connect(rjscDetailReviewSelect)(RJSCDetailsRenewalReview);
